import { reduxForm } from 'redux-form/immutable.js';
import { compose, withProps, setDisplayName } from 'react-recompose';
import { postOrganization } from '~/state/ducks/organizations/operations.js';

import OrganizationForm from './OrganizationForm.js';


const initialValues = {
    general_opportunity_enabled: false,
    disable_email_notifications: false,
    show_impact_meter: false,
    allow_offline: false,
    allow_private_groups: false,
    allow_shoutbox: false,
    bypass_content_moderation: false,
    closed: false,
};

export default compose(
    setDisplayName('OrganizationCreateContainer'),
    reduxForm({
        form: 'organization-create',
        onSubmit: postOrganization,
        initialValues,
    }),
    withProps({
        header: 'Create',
    }),
)(OrganizationForm);
